export default __webpack_public_path__ + "static/media/Monk's Straps of the Nine Springs.388af738.jpg";